module.exports = __webpack_public_path__ + "static/img/css.7d4fe56a.png";